/** Turn API / serializer payloads into a single sentence for toasts. */

var FIELD_LABELS = {
  college_name: "College name",
  year_of_study: "Year of study",
  course: "Course",
  package_code: "Game",
  package_codes: "Games",
  registration_committee: "Committee",
  phone: "Mobile",
  email: "Email",
  name: "Name",
  vehicle_number: "Vehicle number",
  event_id: "Event",
  password: "Password",
  mobile: "Mobile",
};

function fieldLabel(key) {
  if (!key || key === "non_field_errors" || key === "detail") return "";
  return FIELD_LABELS[key] || String(key).replace(/_/g, " ");
}

function firstFromObject(obj) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  if (Array.isArray(obj)) return firstFromObject(obj[0]);
  if (typeof obj !== "object") return String(obj);
  if (obj.non_field_errors) return firstFromObject(obj.non_field_errors);
  if (typeof obj.message === "string" || typeof obj.message === "object") {
    var nested = firstFromObject(obj.message);
    if (nested) return nested;
  }
  if (typeof obj.detail === "string") return obj.detail;
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    var msg = firstFromObject(obj[keys[i]]);
    if (!msg) continue;
    var label = fieldLabel(keys[i]);
    return label ? label + " — " + msg : msg;
  }
  return "";
}

function soften(text) {
  var raw = String(text || "").trim();
  if (!raw) return "Something went wrong. Please try again.";
  if (/EventPackage matching query/i.test(raw)) return "That game or package is no longer available.";
  if (/Booking is currently closed|Booking is closed/i.test(raw)) {
    return "Bookings are not open for this event yet. You can still browse games.";
  }
  if (/Invalid event id/i.test(raw)) return "This event could not be found.";
  if (/Unauthorized|unauthenticated/i.test(raw)) return "Please sign in again to continue.";
  if (/Forbidden/i.test(raw)) return "You do not have access to that action.";
  if (/College Name is required/i.test(raw)) return "College name is required to complete registration.";
  if (/This login can only (register|attribute) /i.test(raw)) return raw;
  if (/You can only register participants for your committee/i.test(raw)) {
    return "This login can only attribute cash sales to its own desk. Any game can be sold.";
  }
  return raw;
}

export function formatApiError(raw) {
  if (raw == null || raw === "") return "Something went wrong. Please try again.";
  if (raw instanceof Error) return formatApiError(raw.message);
  if (typeof raw === "object") return soften(firstFromObject(raw) || "Something went wrong. Please try again.");
  var text = String(raw);
  try {
    if (text.charAt(0) === "{" || text.charAt(0) === "[") {
      return soften(firstFromObject(JSON.parse(text)) || text);
    }
  } catch (e) {
    /* keep original */
  }
  return soften(text);
}

export function staffDisplayName(staff) {
  if (!staff) return "Staff";
  return staff.name || staff.full_name || staff.mobile || staff.mobile_number || "Staff";
}
